import { render } from "./CoursePage.vue?vue&type=template&id=eb4cb94c&scoped=true"
import script from "./CoursePage.vue?vue&type=script&lang=js"
export * from "./CoursePage.vue?vue&type=script&lang=js"

import "./CoursePage.vue?vue&type=style&index=0&id=eb4cb94c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb4cb94c"]])

export default __exports__